<template>
  <main class="arrival-details">
    <div class="arrival-details__body" ref="body">
      <button-back />
      <div class="arrival-details__row">
        <h1 class="arrival-details__title">Поступление товаров от {{ arrival.createdDateTitle }}</h1>
      </div>
      <div class="arrival-details__options">
        <div class="arrival-details__data">
          <date-picker-dialog
            v-bind:allowed-dates="allowedDates"
            v-bind:value="this.currentDate"
            v-on:input="setNewDate"
          >
            <template v-slot:trigger="{ listenerObject }">
              <button
                title="Сменить дату"
                v-if="currentDate"
                type="button"
                v-on="listenerObject"
              >
                <input-text
                  title="Дата поступления"
                  v-bind:readonly="true"
                  v-bind:value="formattedDate"
                />
              </button>
            </template>
          </date-picker-dialog>
        </div>
        <autocomplete-input
          class="arrival-details__options__input"
          item-text="name"
          item-value="id"
          label="Поставщик"
          v-bind:menu-props="{ maxWidth: 'min(80%, 586px)' }"
          v-bind:items="vendorOptions"
          v-bind:violations="vendorInputErrors"
          v-bind:clearable="true"
          v-model="arrival.vendor"
          v-on:input="clearErrors"
          attach />
      </div>
      <div
        class="arrival-details__table__table-wrapper"
        :style="`min-height: ${getMinHeightTable}`"
      >
        <table
          class="arrival-details-table"
          v-if="hasFetchedArrivalDetails"
        >
          <thead>
            <tr class="arrival-details-table__head-line">
              <th class="arrival-details-table__head-cell">№</th>
              <th class="arrival-details-table__head-cell">Название товара</th>
              <th class="arrival-details-table__head-cell">Единица измерения</th>
              <th class="arrival-details-table__head-cell">Количество</th>
              <th class="arrival-details-table__head-cell">Цена</th>
              <th class="arrival-details-table__head-cell">Итого</th>
              <th class="arrival-details-table__head-cell head-cell head-cell__button" />
            </tr>
          </thead>
          <tbody>
            <tr
              class="arrival-details-table__body-line"
              v-bind:key="index"
              v-for="{
                name,
                unit,
                count,
                index,
                price,
                getFinalPrice,
              } in arrival.products"
            >
              <td class="arrival-details-table__body-cell">{{ index + 1 }}</td>
              <td class="arrival-details-table__body-cell">
                {{ name }}
              </td>
              <td class="arrival-details-table__body-cell">
                {{ unit }}
              </td>
              <td class="arrival-details-table__body-cell">
                <input-number
                  title=""
                  class="input-number"
                  max="99999"
                  min="1"
                  allowed-null
                  without-native-controls
                  v-bind:name="`products.${index}.count`"
                  v-bind:value="count"
                  v-on:blur="onBlurCountInput(index, count)"
                  v-on:focus="onFocusCountInput(index, count)"
                  v-bind:violations="productsInputErrors[index].count"
                  v-on:input="onChangeCount(index, $event)" />
              </td>
              <td class="arrival-details-table__body-cell">
                <price-input-rub
                  class="arrival-details-table__price"
                  v-bind:value="price"
                  v-on:input="onChangePrice(index, $event)"
                  v-bind:violations="productsInputErrors[index].price"
                />
              </td>
              <td class="arrival-details-table__body-cell">
                <input-layout title="">
                  <the-rub
                    currency="тнг"
                    v-bind:kop="getFinalPrice()"
                  />
                </input-layout>
              </td>
              <td class="arrival-details-table__body-cell body-cell body-cell__button">
                <button
                  class="arrival-details__buttons-delete"
                  type="button"
                  title="Удалить"
                  v-on:click="removeProduct(index)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="arrival-details__buttons">
        <button
          type="button"
          class="arrival-details__buttons-add"
          v-on:click="toggleShownPickerProduct"
        >
          Добавить товар
        </button>
        <button
          type="button"
          class="arrival-details__buttons-submit"
          v-on:click="editArrival"
        >
          Сохранить
        </button>
      </div>
      <picker-items
        class="arrival-details__picker"
        v-bind:items="productOptions"
        title="Выберите товар"
        v-model="shownProductPicker"
        v-on:add="selectingProduct"
        v-on:search="fetchProducts"
      >
        <template
          v-slot:default="{
            item,
            emitAdd,
            onSelectSetColor,
          }">
          <button
            class="picker__item__button"
            type="button"
            v-on:click="emitAdd(item.id); onSelectSetColor($event)">
            <span>{{ item.name }}</span>
          </button>
          <span>
            {{ item.unit }}
          </span>
        </template>
        <template
          v-slot:bottom
        >
          <button
            class="picker__item__bottom"
            type="button"
            v-on:click="openProductDialogForm">
            <span> Добавить новый товар </span>
          </button>
        </template>
      </picker-items>
    </div>
    <modal-dialog
      title="Добавить новый товар"
      width="100%"
      max-width="450px"
      content-class="warehouse-product-add-modal"
      v-bind:value="shownProductDialogForm"
      v-on:on-click-outside="closeProductDialogForm"
      v-on:input="closeProductDialogForm"
      with-cross>
      <form-product
        v-if="shownProductDialogForm"
        v-bind:has-create-unit="false"
        v-bind:category-options="categoryOptions"
        v-bind:unit-options="unitOptions"
        v-bind:vendor-options="vendorOptions"
        v-bind:initial-name="product.name"
        v-bind:initial-category="product.category"
        v-bind:initial-manufacturer="product.manufacturer"
        v-bind:initial-unit="product.unit"
        v-bind:initial-vendor="product.vendor"
        v-bind:initial-count-in-pack="product.countInPack"
        v-bind:initial-critical-stock-level="product.criticalStockLevel"
        v-bind:input-errors="inputErrors"
        v-on:submit="createProduct"
        v-on:create-category="openCategoryForm"
        v-on:close="closeProductDialogForm" />
    </modal-dialog>
    <modal-dialog
      content-class="products-page__modal"
      title="Создать категорию"
      v-model="showProductCategoryDialogForm"
      v-on:input="closeProductCategoryDialogForm"
      with-cross
    >
      <form-product-category
        v-bind:category-id="category.id"
        v-bind:initial-name="category.name"
        v-bind:input-errors="inputErrors"
        v-on:submit="createProductCategory"
        v-on:close="closeProductCategoryDialogForm" />
    </modal-dialog>
    <modal-dialog-prevent-leave
      v-bind:is-shown="isShownDialogLeaveConfirm"
      v-on:back="isShownDialogLeaveConfirm = false"
      v-on:leave="leaveWithoutSave"
      v-on:save="saveAndLeave" />
  </main>
</template>

<script>
import notifierMixin from '@/mixins/notifierMixin';
import { builtInDialogMixin } from '@/components/ClinicPanelDialog.vue';
import { Arrival, ArrivalProduct, ArrivalRequest } from '@/storage/gateways/ArrivalGateway';
import { Product, ProductCategory } from '@/storage/gateways/ProductGateway';
import ModalDialog from '@/components/ModalDialog.vue';
import FormProduct from '@/components/Warehouse/FormProduct.vue';
import ButtonBack from '@/components/ButtonBack.vue';
import AutocompleteInput from '@/components/AutocompleteInput.vue';
import InputLayout from '@/components/InputLayout.vue';
import PriceInputRub from '@/components/PriceInputRub.vue';
import InputNumber from '@/components/InputNumber.vue';
import TheRub from '@/components/TheRub.vue';
import { List } from 'monet';
import PickerItems from '@/components/PickerItems.vue';
import FormProductCategory from '@/components/Warehouse/FormProductCategory.vue';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import InputText from '@/components/InputText.vue';
import dateMixin from '@/mixins/dateMixin';
import ModalDialogPreventLeave from '@/components/ModalDialogPreventLeave.vue';
import preventLeaveWithoutConfirmMixin from '@/mixins/preventLeaveWithoutConfirmMixin';

/**
 * @description Примесь товара.
 * @type {Vue}
 */
const productMixin = {
  data() {
    return {
      product: new Product(),
      shownProductDialogForm: false,
    };
  },
  methods: {
    /**
     * @description Сохранить и покинуть
     * @returns {void}
     */
    saveAndLeave() {
      this.editArrival();
      this.actionAfterClosingDialogLeaveConfirm();
      this.isShownDialogLeaveConfirm = false;
    },
    openProductDialogForm() {
      this.shownProductDialogForm = true;
      this.toggleShownPickerProduct();
      this.inputErrors = {};
    },
    closeProductDialogForm() {
      this.shownProductDialogForm = false;
      this.product = new Product();
    },
    /**
     * @description Создать товар.
     * @param {ProductRequest} request
     */
    createProduct(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.title);
        this.inputErrors = {};
        this.fetchProducts().finally(() => {
          this.selectingProduct(response.product_id);
          this.closeProductDialogForm();
        });
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.inputErrors = error.allCauses();
      };
      this
        .$productGateway
        .create(request.toQuery())
        .then((result) => result.fold(onFail, onSuccess));
    },
  },
};

/**
 * @description Примесь категорий товаров.
 * @type {any}
 */
const categoryMixin = {
  data() {
    return {
      category: new ProductCategory(),
      showProductCategoryDialogForm: false,
    };
  },
  methods: {
    /**
     * @description Обработать выбор категорий.
     * @param {array} categories
     */
    onSelectingCategory(categories) {
      this.selectedCategories = categories;
      this.fetchProductList(this.sort, this.selectedCategories);
    },
    /**
     * @description Открыть форму для работы с категорией.
     * @returns {void}
     */
    openCategoryForm() {
      this.category = new ProductCategory();
      this.showProductCategoryDialogForm = true;
    },
    /**
     * @description Закрыть форму категории.
     * @returns {void}
     */
    closeProductCategoryDialogForm() {
      this.showProductCategoryDialogForm = false;
    },
    /**
     * @description Создать категорию товара.
     * @param {ProductCategoryRequest} request
     */
    createProductCategory(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.title);
        this.inputErrors = {};
        this.closeProductCategoryDialogForm();
        this.fetchOptions().then(() => {
          this.product.category = response.category_id;
        });
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.inputErrors = error.allCauses();
      };
      this
        .$productGateway
        .createProductCategory(request.toQuery())
        .then((result) => result.fold(onFail, onSuccess));
    },
  },
};

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Страница списка поступления товаров.
 * @type {Vue}
 */
export default {
  name: 'ClinicPanelWarehouseProductArrival',
  components: {
    ModalDialogPreventLeave,
    FormProductCategory,
    PickerItems,
    TheRub,
    InputNumber,
    PriceInputRub,
    InputLayout,
    AutocompleteInput,
    ButtonBack,
    FormProduct,
    ModalDialog,
    DatePickerDialog,
    InputText,
  },
  computed: {
    /**
     * @description Предотвращать уход со страницы.
     * @type {boolean}
     */
    needPreventLeave(vm) {
      return vm.isArrivalChange || vm.isArrivalDateChange;
    },
    /**
     * @description Дата поступления изменилась
     * @returns {boolean}
     */
    isArrivalDateChange() {
      return this.arrival.arrivalDate !== this.formattedDate;
    },
    /**
     * @description Приход изменился
     * @returns {boolean}
     */
    isArrivalChange() {
      return this.arrival.isChanged();
    },
    formattedDate() {
      const date = this.currentDate.getDate();
      const month = this.currentDate.getMonth() + 1;
      const year = this.currentDate.getFullYear();
      return [date, month, year]
        .map((part) => part.toString().padStart(2, '0'))
        .join('.');
    },
    vendorInputErrors: resolveInputErrors('vendor'),
    productInputErrors: resolveInputErrors('product'),
    productsInputErrors() {
      const countProducts = this.arrival.products.length - 1;
      const errors = new Array(this.arrival.products.length).fill(null);
      for (let i = 0; i <= countProducts; i += 1) {
        const count = this.inputErrors[`product-${i}-count`] ?? [];
        const price = this.inputErrors[`product-${i}-price`] ?? [];
        errors[i] = {
          count,
          price,
        };
      }
      return errors;
    },
    getMinHeightTable() {
      return this.arrival?.products.length > 2 ? '275px' : 'min-content';
    },
  },
  created() {
    this.fetchOptions();
    this.fetchProducts();
    this.fetchArrival();
  },
  data() {
    return {
      currentDate: new Date(),
      hasFetchedArrivalDetails: false,
      arrival: new Arrival('', '', [], new Date()),
      inputErrors: {},
      vendorOptions: [],
      productOptions: [],
      unitOptions: [],
      categoryOptions: [],
      /**
       * @description Выбранный товар.
       * @type {string}
       */
      selectedProduct: '',
      /**
       * @description Ключ компонента выбора товара.
       * @type {number}
       */
      autocompleteKey: 0,
      shownProductPicker: false,
    };
  },
  methods: {
    /**
     * @description Установить новую дату
     * @param {Date} date
     */
    setNewDate(date) {
      this.currentDate = date;
    },
    /**
     * @description Функция описывающая условие доступности выбора дат в datepicker
     * @param {String} candidate Строка с датой в формате Y-m-d
     * @return {boolean}
     */
    allowedDates(candidate) {
      return (new Date(candidate)) <= new Date();
    },
    /**
     * @description Переключить отображение пикера товаров.
     */
    toggleShownPickerProduct() {
      this.shownProductPicker = !this.shownProductPicker;
    },
    /**
     * @description Редактировать поступления.
     */
    editArrival() {
      const request = this.makeRequest();
      const onSuccess = ({ title }) => {
        this.notifySuccess(title);
        this.inputErrors = {};
        this.fetchArrival();
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.inputErrors = error.allCauses();
      };
      this
        .$arrivalGateway
        .edit(request.getId(), request.toQuery())
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Очистить ошибки.
     */
    clearErrors() {
      this.inputErrors = {};
    },
    /**
     * @description Получить поступления.
     */
    async fetchArrival() {
      const onSuccess = ({ arrival }) => {
        this.arrival = arrival;
        this.hasFetchedArrivalDetails = true;
        const dateParts = this.arrival.arrivalDate.split('.');
        this.currentDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$arrivalGateway
        .viewArrival(this.arrivalId)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Получить опции.
     * @returns {Promise}
     */
    fetchOptions() {
      const onSuccess = (
        {
          vendors,
          units,
          categories,
        },
      ) => {
        this.vendorOptions = vendors;
        this.unitOptions = units;
        this.categoryOptions = categories;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      return this
        .$arrivalGateway
        .viewOptions()
        .then((result) => result.fold(onFail, onSuccess));
    },
    fetchProducts(searchQuery = '') {
      const onSuccess = ({ products }) => {
        this.productOptions = products;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      return this
        .$productGateway
        .getAll(
          { type: '', order: '' },
          0,
          [],
          searchQuery,
        )
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать добавление товара.
     * @param {Object} product Товар.
     * @returns {void}
     */
    onAddingPriceProduct(product) {
      const addingProduct = new ArrivalProduct(
        this.arrival.products.length,
        product.id,
        product.name,
        0,
        product.unit,
        0,
      );
      this.$set(this.arrival.products, this.arrival.products.length, addingProduct);
    },
    /**
     * @description Обработать изменение количества товара.
     * @param {number} productIndex Индекс товара.
     * @param {number} count        Количество.
     * @returns {void}
     */
    onChangeCount(productIndex, count) {
      const updater = (product) => product.setCount(count);
      this.arrival.products = this.updateProductByIndex(updater)(productIndex);
    },
    /**
     * @description Обработать изменения единицы измерения.
     * @param {number} productIndex Индекс товара.
     * @param {string} price        Цена товара.
     * @returns {void}
     */
    onChangePrice(productIndex, price) {
      const updater = (product) => product.setPrice(price);
      this.arrival.products = this.updateProductByIndex(updater)(productIndex);
    },
    /**
     * @description Обработать потерю фокуса с поля количества товара.
     * @param {number} serviceIndex Индекс товара.
     * @param {number} count        Количество.
     * @returns {void}
     */
    onBlurCountInput(serviceIndex, count) {
      if (count === '') {
        this.onChangeCount(serviceIndex, '1');
      }
    },
    /**
     * @description Обработать фокус на поле количества товара.
     * @param {number} serviceIndex Индекс товара.
     * @param {number} count        Количество.
     * @returns {void}
     */
    onFocusCountInput(serviceIndex, count) {
      if (count.toString().charAt(0) === '0') {
        this.onChangeCount(serviceIndex, '');
      }
    },
    /**
     * @description Создать запрос.
     * @returns {ArrivalRequest}
     */
    makeRequest() {
      const currentDate = this.formatDateToISO(this.currentDate, true);
      return new ArrivalRequest(
        this.arrivalId,
        this.arrival.vendor,
        this.arrival.products,
        currentDate,
      );
    },
    /**
     * @description Удалить товар поступления.
     * @param {number} productIndex Индекс товара.
     * @returns {void}
     */
    removeProduct(productIndex) {
      const exclude = (index) => (product) => product.index !== index;
      const reindex = (acc, product) => acc.cons(
        new ArrivalProduct(
          acc.size(),
          product.id,
          product.name,
          product.count,
          product.unit,
          product.price,
        ),
      );
      this.arrival.products = List
        .fromArray(this.arrival.products)
        .filter(exclude(productIndex))
        .foldLeft(List())(reindex)
        .reverse()
        .toArray();
    },
    /**
     * @description Получить обновление услуг плана по индексу.
     * @param {function(Product): Product} updater Обновление товара.
     * @returns {function(Number): Product[]}
     */
    updateProductByIndex(updater) {
      return (index) => this.arrival.products.map(
        (product) => (product.index === index ? updater(product) : product),
      );
    },
    /**
     * @description Обработать выбор товара.
     * @returns {void}
     */
    selectingProduct(productId) {
      const product = this.productOptions.find((item) => item.id === productId);
      this.selectedProduct = '';
      this.autocompleteKey += 1;
      this.onAddingPriceProduct(product);
      this.clearErrors();
    },
  },
  mixins: [
    notifierMixin,
    builtInDialogMixin,
    productMixin,
    categoryMixin,
    dateMixin,
    preventLeaveWithoutConfirmMixin,
  ],
  props: {
    arrivalId: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";

.warehouse-product-add-modal {
  overflow-y: visible;
}

.arrival-details {
  table {
    th:first-child {
      width: 60px;
    }
    th:nth-child(n+2) {
      width: 25%;
    }
    th.head-cell {
      &__button {
        width: 50px;
      }
    }
    .body-cell {
      &__button {
        text-align: center;
      }
    }
  }
}

.arrival {
  &-details {

    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;

    &__buttons {
      justify-self: end;
      display: grid;
      grid-template-columns: repeat(2, minmax(150px, 240px));
      grid-gap: 20px;
      max-width: 760px;
      margin: 20px 0 0 0;

      &-add {
        @include buttons.btn-transparent(100%, 48px, 16px);
        &::before {
          content: "+";
          margin-right: 4px;
        }
      }

      &-export {
        @include buttons.btn-transparent(100%, 48px, 16px);

        &:before {
          content: "";
          background-image: url("@/assets/img/download-file-blue.svg");
          background-repeat: no-repeat;
          background-size: contain;
          width: 20px;
          height: 20px;
          margin: 0 8px 0 0;
        }

        &:disabled {
          color: var(--unfocus-color);
          border-color: var(--unfocus-color);
          background-color: transparent;
        }
      }

      &-submit {
        @include buttons.btn-blue(100%, 48px, 16px);
        flex-shrink: 0;
        max-width: 250px;
      }

      &-delete {
        display: inline-block;
        width: 25px;
        height: 25px;
        background: no-repeat 50%;
        background-image: url("@/assets/img/exit-grey.svg");
        background-size: 12px 12px;
        cursor: pointer;
        &:hover {
          background-image: url("@/assets/img/exit-blue.svg");
        }
      }
    }

    &__body {
      display: flex;
      flex-direction: column;
      gap: 2rem;
      padding: 38px 20px 48px 23px;
      width: 100%;
      overflow-y: auto;
      overflow-x: hidden;
    }

    &__row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    &__options {
      display: grid;
      grid-template-columns: auto 1fr;
      align-items: center;
      gap: 25px;
      max-width: 600px;
      &__input {
        width: 100%;
        .v-text-field {
          margin-top: 0;
          label {
            color: #90a0b7;
          }
          input {
            max-height: 40px;
            line-height: 24px;
          }
        }
      }
    }
    &__data {
      label {
        text-align: left;
      }
      input {
        background: no-repeat right 10px center;
        background-image: url("@/assets/img/calendar-grey.svg");
      }
    }
    &__table {
      display: flex;
      flex-direction: column;
      gap: 2rem;
      overflow: scroll;
      padding: 2rem 1rem;
      height: 100%;

      &__table-wrapper {
        max-height: 650px;
        overflow-x: auto;
      }
    }

    &-table {
      position: relative;
      border-collapse: collapse;
      font-size: .875rem;
      line-height: 1rem;
      overflow: auto;
      table-layout: fixed;
      width: 100%;

      &__head-line {
        border-bottom: 2px solid var(--action-color);
        font-weight: 700;
      }

      &__head-cell {
        position: sticky;
        top: 0;
        padding: 10px 8px;
        text-align: left;
        background-color: #ffffff;
        z-index: 1;
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -2px;
          width: 100%;
          border-bottom: 2px solid var(--action-color);
        }
      }

      &__body-line {
        border-bottom: 1px solid var(--fill-color);
      }

      &__body-cell {
        overflow: hidden;
        padding: 15px 8px;
        text-align: left;
        text-overflow: ellipsis;
        text-transform: none;
        white-space: pre-line;
        .input-number,
        .price-input-rub {
          max-width: 110px;
        }
      }
    }
  }
}

@media screen and (max-width: 960px) {
  .arrival {
    &-details {
      flex-direction: column;
      &__row {
        flex-direction: column;
        gap: 15px;
      }
    }
  }
}

@media screen and (max-width: 950px) {
  .arrival-details {
    .arrival-details-table  {
      min-width: 950px;
    }
  }
}

@media screen and (max-width: 640px) {
  .arrival {
    &-details {
      &__body {
        padding: 38px 10px 140px;
        width: 100%;
        overflow-y: scroll;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .arrival {
    &-details {
      &__options {
        grid-template-columns: 1fr;
      }
    }
  }
}

@media screen and (max-height: 760px) {
  .arrival {
    &-details {
      &__body {
        padding-bottom: 38px;
      }
    }
  }
}

.picker {
  &__item {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    &__button {
      max-width: 400px;
      text-align: left;
      transition: color 0.2s;
      > span.selected {
        color: #0569ac;
      }
      @media (hover: hover) {
        &:hover {
          color: #0076C4;
        }
      }
      &:active {
        color: #0569ac;
      }
    }
    &__bottom {
      text-align: center;
      transition: color 0.2s;
      @include buttons.btn-transparent(100%, 48px, 16px);
      margin-inline: auto;
      max-width: 250px;
    }
  }
}

</style>
